import { Stack } from "@mui/material";
import React from "react";
import { DetailBoxWrapper } from "./DetailBoxWrapper";

export type TitleDatailInlineV2Props = {
  dt: React.ReactNode;
  dd: React.ReactNode;
  dtColor?: string;
  ddColor?: string;
};
export const TitleDatailInlineV2 = ({ dt, dd, ddColor, dtColor = "#AAAABE" }: TitleDatailInlineV2Props) => {
  return (
    <Stack sx={{ overflow: "hidden" }} direction="row" spacing={2} justifyContent={"space-between"} display={"flex"}>
      <DetailBoxWrapper
        sx={{
          fontWeight: 500,
          color: dtColor,
        }}
      >
        {dt}
      </DetailBoxWrapper>
      <DetailBoxWrapper
        sx={{
          fontWeight: 500,
          textAlign: "right",
          color: ddColor,
        }}
      >
        {dd}
      </DetailBoxWrapper>
    </Stack>
  );
};
